import { useRouteError } from "react-router-dom";
import { tokenLoader } from "src/util/auth";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

function ErrorPage() {
  const token = tokenLoader();
  const navigate = useNavigate();
  const error = useRouteError();

  useEffect(() => {
    if (!token) {
      return navigate("/auth");
    }
  }, [token, navigate]);

  let title = "An error occurred!";
  let message = "Something went wrong!";

  if (error.status === 500) {
    message = error.data.message;
  }

  if (error.status === 401) {
    message = error.data.message;
  }

  if (error.status === 404) {
    title = "Not found!";
    message = "Could not find resource or page.";
  }

  return (
    <>
        <div style={{color:"#FFF",textAlign:"center",marginTop:"3rem"}}>
          <h1>{title}</h1>
          <p>{message}</p>
        </div>
    </>
  );
}

export default ErrorPage;
